import type { APIPortal } from "models/types/api-listing";
import { apiClient } from "utils/api-client";
import { createModel } from "utils/models";

export type AgencyContact = {
  id: string;
  name: string;
  role: string;
  phone: string;
  email: string;
  imageUrl?: string;
};

export type ListingAddress = {
  full_address: string;
  short_address: string;
};

export type UserListing = {
  id: string;
  address: ListingAddress;
  remote_record_id: string;
};

export type Referrer = {
  product: string;
  account_id: string | null;
};

export type Silo = {
  internal_name: string;
  display_name: string;
  logo: string;
};

export type SessionData = {
  email: string;
  remote_id: string;
  given_name: string;
  family_name: string;
  roles: string[];
  referrer: Referrer;
  related: {
    listings: UserListing[];
  };
  region: APIPortal["region"];
  silo: Silo | null;
  contact_name: string;
  salutation: string | null;
};

export type SessionResponse = {
  data: SessionData;
};

export const sessionModel = createModel("session", {
  queries: {
    read: (token) => ({
      queryKey: ["read"],
      queryFn: async () => {
        const response = await apiClient.get<SessionResponse>(`/user`, {
          token,
        });
        return response.data;
      },
      enabled: Boolean(token),
    }),
  },
});
